// import { AiFillGithub } from "@react-icons/all-files/ai/AiFillGithub";
// import parseGithubURL from "@utils/parseGithubURL";
import styled from "styled-components";

function ProjectCard({ title, description, stack, timeline, companyImage, companyLink, position }) {
  const handleCardClick = () => {};

  return (
    <BigContainer>
      <MainWrapper onClick={handleCardClick}>
        <Description>

          <Title>
            {title}
          </Title>

          <Section>

            <InfoSection>
                <SubTitle>
                    <Position> {position} </Position>
                    <Time>{timeline}</Time>
                </SubTitle>
                <HorizontalBar />
                <Desc>{description}</Desc>
                <StackTitle>Skills</StackTitle>
                <StackContainer>
                    {stack.map((el, idx) => {
                    return <Stack key={idx}>{el}</Stack>;
                    })}
                </StackContainer>
            </InfoSection>

            <ImageSection>
                <a href={companyLink} target="_blank" rel="noopener noreferrer">
                <Image src={`/companies/${companyImage}`} alt="Google Developer Student Club" />
                </a>
            </ImageSection>


          </Section>

            

        </Description>
      </MainWrapper>
    </BigContainer>
  );
}

export default ProjectCard;

const BigContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const MainWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  background-color: black;
  color: white;
`;

const Description = styled.div`
  width: 100%;

  margin-bottom: 5vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2vh;
`;

const Title = styled.h3`
  position: relative;
  /* padding: 5px; */
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 3.5vw;
  line-height: 5vw;

  overflow: hidden;
`;

const Section = styled.div`
    display: flex;
    justify-content: space-around;
`;

const InfoSection = styled.div`
    width: 50vw;
`;

const ImageSection = styled.div`
    margin: 0 5vw ;
    width: 20vw;
    /* object-fit: cover; */
    display: flex;
    justify-content: center;
    align-items: center;

`;

const Image = styled.img`
    width: 80%;
    height: auto;
    object-fit: contain;
    border-radius: 25px;
    opacity: 0.8;
    &:hover{
        opacity: 0.3;
    }
`;

const SubTitle = styled.h3`
  display: flex;
  justify-content: space-between;
  
  line-height: 2vw;
  overflow: hidden;
`;

const Position = styled.h4`
    font-size: 2.1vw;
`;

const Time = styled.h6`
font-size: 1.2vw;
`;

const HorizontalBar = styled.hr`
  width: 100%;
  height: 3px;

  margin: 0%.5 0;

  background-color: white;
`;

const Desc = styled.p`
  font-size: 1.2vw;
  font-weight: 300px;
  line-height: 1.3vw;
  margin-top: 1.3vw;
  margin-bottom: 1vw;
  letter-spacing: 0.5px;
  text-align: justify;
`;

const StackTitle = styled.h3`
  font-size: 2vw;
  /* margin-bottom: 1vw; */
`;

const StackContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* grid-gap: 1vmax; */
`;

const Stack = styled.h5`
  font-size: 1.3vw;
  padding: 2px;
`;